/* COVA header: scrolled state, mobile menu offset and sub-levels, account drawer views */
(function () {
  'use strict';
  function ready(fn) { if (window.CV && window.CV.register) fn(); else window.addEventListener('load', fn); }
  ready(function () {
    CV.register('cv-header', function (header) {
      var bar = header.querySelector('.cv-header__bar');
      function update() { header.classList.toggle('is-scrolled', window.scrollY > 100); }
      window.addEventListener('scroll', update, { passive: true });
      update();

      var menu = header.querySelector('#cv-mobile-menu');
      if (menu) {
        var root = menu.querySelector('[data-cv-mmenu-root]');
        menu.addEventListener('click', function (e) {
          var sub = e.target.closest('[data-cv-sub]');
          if (sub) {
            var panel = menu.querySelector('[data-cv-mmenu-sub="' + sub.getAttribute('data-cv-sub') + '"]');
            if (panel) { root.hidden = true; panel.hidden = false; }
          }
          if (e.target.closest('[data-cv-sub-back]')) {
            menu.querySelectorAll('[data-cv-mmenu-sub]').forEach(function (p) { p.hidden = true; });
            root.hidden = false;
          }
        });
        menu.addEventListener('cv:close', function () {
          menu.querySelectorAll('[data-cv-mmenu-sub]').forEach(function (p) { p.hidden = true; });
          if (root) root.hidden = false;
        });
      }

      // account drawer: login / recover / register views
      var acc = header.querySelector('#cv-account-drawer');
      if (acc) {
        function show(view) {
          acc.setAttribute('data-view', view);
          acc.querySelectorAll('[data-cv-view]').forEach(function (n) { n.hidden = n.getAttribute('data-cv-view') !== view; });
        }
        acc.addEventListener('click', function (e) {
          var sw = e.target.closest('[data-cv-switch]');
          if (sw) { e.preventDefault(); show(sw.getAttribute('data-cv-switch')); }
        });
        acc.addEventListener('cv:close', function () { show('login'); });
      }
    });
  });
})();
